import { TTicketDetails } from '@daymade/api-contracts';
import { GameType, PurchasingAction } from '@daymade/common-lib/dbEnums';
import DashboardComponentHeader from 'components/dashboard/common/DashboardComponentHeader';
import { IEntryLine } from 'types/Draws';
import TicketStack from './TicketStack';

import styles from './EntriesAndStats.module.css';

const SUBSCRIPTION_ACTIONS = new Set([
  PurchasingAction.SUBSCRIPTION,
  PurchasingAction.SUBSCRIPTION_INITIAL,
  PurchasingAction.SUBSCRIPTION_UPGRADE,
]);

const groupEntriesByPurchasingAction = (tickets: TTicketDetails[]) => {
  const subscriptionTickets = tickets.filter((ticket) =>
    SUBSCRIPTION_ACTIONS.has(ticket.paymentRequest.purchasingAction),
  );

  const addonTickets = tickets.filter(
    (ticket) =>
      !SUBSCRIPTION_ACTIONS.has(ticket.paymentRequest.purchasingAction),
  );

  const subscriptionEntries =
    subscriptionTickets[0]?.entries
      .filter(
        (entry): entry is Extract<typeof entry, { type: 'LOTTERY' }> =>
          entry.type === GameType.LOTTERY,
      )
      .map((entry) => entry as unknown as IEntryLine) ?? [];

  const addonEntries = addonTickets.flatMap((ticket) =>
    ticket.entries
      .filter(
        (entry): entry is Extract<typeof entry, { type: 'LOTTERY' }> =>
          entry.type === GameType.LOTTERY,
      )
      .map((entry) => entry as unknown as IEntryLine),
  );

  return { subscriptionEntries, addonEntries };
};

const TicketEntries = ({ tickets }: { tickets: TTicketDetails[] }) => {
  const { subscriptionEntries, addonEntries } =
    groupEntriesByPurchasingAction(tickets);

  return (
    <div className={styles.ticketEntriesContainer}>
      {subscriptionEntries.length > 0 && (
        <TicketStack entries={subscriptionEntries} />
      )}

      {addonEntries.length > 0 && (
        <div>
          <DashboardComponentHeader
            title={<div className={styles.titleContainer}>Add-on entries</div>}
            subtitle={'Entered into the next draw'}
          />
          <TicketStack entries={addonEntries} />
        </div>
      )}
    </div>
  );
};

export default TicketEntries;
